// import classNames from 'classnames';
import {ReactNode} from 'react';
import {Badge as LuffyBadge, BadgeProps as LuffyBadgeProps} from '@baidu/luffy-comp-badge';

// import {ThemeVariables} from '../style/Theme';
// import {BindEventProps} from '../interface';

export enum BadgeType {
    Standard = 'standard',
    Dot = 'dot',
    Status = 'status',
}

export enum BadgeColor {
    Inactive = 'inactive',
    Error = 'error',
    Success = 'success',
    Warning = 'warning',
    Primary = 'primary',
}

interface BadgeProps extends LuffyBadgeProps {
    children?: ReactNode;
}

export default function Badge(props: BadgeProps) {
    const {children, ...badgeProps} = props;
    return (
        <LuffyBadge {...badgeProps}>
            {children}
        </LuffyBadge>
    );
}
